// CSS
import { fileDownload } from 'Admin/Component/AdFunc'
import { useState } from 'react'
import '_Asset/css/User/Page/UiComponent/uielement.css'

const UIElement = () => {

  const [checkIdx, setCheckIdx] = useState('')
  const [curType, setCurType] = useState('')

  const [switchBtn, setSwitchBtn] = useState(false);
  const [switchIdx, setSwitchIdx] = useState('');
  const [switchType, setSwitchType] = useState('');

  return (
    <div className="componentBox">
      <div className="pageTit">
        <h2>UIElement <button type="button" className="btn round_10 sm sfrtBlue" onClick={() => fileDownload('ui_component', 'pgui.css')}>UI Component CSS 다운로드</button></h2>
        <p>Components: <span>Combined Elements, CheckBox, Radio Button, Switch Button</span></p>
      </div> 

      <div className="useWay">
        <h2>How to use the UIElement kit</h2>
        <p>Click UI Element to copy and paste where you want to use it.</p>
        <p>Bagic Class: <span>msgBox / check / switchBtn / tagBox</span></p>
        <p>Ex. class="<span>msgBox black top</span>"</p>
      </div>

      {/* Message Box Styles Types */}
      {elementArr.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>Message Box를 눌러 태그를 복사 할 수 있습니다.</p>
          
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>

          <div className="contWrap">
            {key.elementList.map((item, i) => 
              <div className="fieldGroup" key={i}>
                <div className="field">
                  <div className={`msgBox ${item.pos} ${item.color}`}>
                    <h2>{item.title}</h2>
                    <p>{item.content}</p>
                  </div>
                </div>

                <h2 className="fieldTxt">{item.text}</h2>
              </div>
            )}
          </div>
        </div>
      )}

      {/* CheckBox Styles */}
      {checkBoxArr.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>CheckBox를 눌러 태그를 복사 할 수 있습니다.</p>
          
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>

          <div className="contWrap">
            {key.checkBoxList.map((item, i) => 
              <div className="fieldGroup" key={i}>
                <div className="checkGroup">
                  <input type="checkbox" className={`check ${item.size} ${item.type} ${item.color}`} id={`${key.type}_${i}`} onClick={(e) => {setCheckIdx(i); setCurType(key.type)}} checked={item.checked} disabled={item.disabled}/>
                  <label htmlFor={`${key.type}_${i}`}></label>

                  <label htmlFor={`${key.type}_${i}`}>{item.text}</label>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Radio Styles */}
      {radioArr.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>CheckBox를 눌러 태그를 복사 할 수 있습니다.</p>
          
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>

          <div className="contWrap">
            {key.radioList.map((item, i) => 
              <div className="fieldGroup" key={i}>
                <div className="checkGroup">
                  <input type="radio" className={`check ${item.size} ${item.type} ${item.color}`} id={`${key.type}_${i}`} onChange={(e) => {setCheckIdx(i); setCurType(key.type)}} checked={item.checked || (checkIdx === i && curType === key.type) ? true : false} disabled={item.disabled}/>
                  <label htmlFor={`${key.type}_${i}`}></label>

                  <label htmlFor={`${key.type}_${i}`}>{item.text}</label>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Switch Button Styles */}
      {switchArr.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>Switch 버튼을 눌러 태그를 복사 할 수 있습니다.</p>
          
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>

          <div className="contWrap">
            {key.switchList.map((item, i) => 
              <div className="fieldGroup" key={i}>
                <div className="field">
                  <input type="checkbox" id={`${key.type}_${i}`} className={`switchBtn round_100 ${item.type} ${item.size} ${item.color}`} onClick={(e) => {setSwitchBtn(e.target.checked); setSwitchIdx(i); setSwitchType(key.type)}} disabled={item.disabled} />
                  <label htmlFor={`${key.type}_${i}`}>
                    <p className="switchCircle"></p>
                    {item.onTxt ? <span>{switchBtn && switchIdx === i && switchType === key.type ? 'ON' : 'OFF'}</span> : ''}
                  </label>

                  {/* <button type="button" className={`switchBtn round_100 ${item.type} ${item.size} ${item.color} ${switchBtn && switchIdx === i && switchType === key.type ? 'on' : ''}`} onClick={() => {setSwitchBtn(!switchBtn); setSwitchIdx(i); setSwitchType(key.type)}}>
                    <p className="switchCircle"></p>
                    {item.onTxt ? <span className={switchBtn && switchIdx === i && switchType === key.type ? 'on' : ''}>{switchBtn && switchIdx === i && switchType === key.type ? 'ON' : 'OFF'}</span> : ''}
                  </button> */}
                </div>
                
                <h2 className="fieldTxt">{item.text}</h2>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Tag Box Styles */}
      {tagArr.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>태그를 눌러 태그를 복사 할 수 있습니다.</p>
          
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p> 
          </div>

          <div className="contWrap">
            {key.tagList.map((item, i) => 
              <div className="fieldGroup" key={i}>
                <div className="field">
                  <label className={`tagBox ${item.size} ${item.type} ${item.round}`}>
                    <p>Tag</p>
                    <button type="button" className="icofont-close"></button>
                  </label>
                </div>
                
                <h2 className="fieldTxt">{item.text}</h2>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

const elementArr = [
  {
    name: 'Message Box',
    class: 'Class: [msgBox / black / top, right, bottom, left]',
    elementList: [
      { text: 'White - Top', title: '18/02/2022', content: '3 Days ago', pos: 'top', color: ''},
      { text: 'White - Right', title: '18/02/2022', content: '3 Days ago', pos: 'right', color: ''},
      { text: 'White - Bottom', title: '18/02/2022', content: '3 Days ago', pos: 'bottom', color: ''},
      { text: 'White - Left', title: '18/02/2022', content: '3 Days ago', pos: 'left', color: ''},
      { text: 'Black - Top', title: '18/02/2022', content: '3 Days ago', pos: 'top', color: 'black'},
      { text: 'Black - Right', title: '18/02/2022', content: '3 Days ago', pos: 'right', color: 'black'},
      { text: 'Black - Bottom', title: '18/02/2022', content: '3 Days ago', pos: 'bottom', color: 'black'},
      { text: 'Black - Left', title: '18/02/2022', content: '3 Days ago', pos: 'left', color: 'black'},
    ]
  },
]

const checkBoxArr = [
  {
    name: 'CheckBox Size',
    class: 'Class: [check blue / xs, sm, md, lg, xl]',
    type: 'checkSize',
    checkBoxList: [
      { text: 'X-Small', size: 'xs', color: 'blue' },
      { text: 'Small', size: 'sm', color: 'blue'},
      { text: 'Medium', size: 'md', color: 'blue' },
      { text: 'Large', size: 'lg', color: 'blue' },
      { text: 'X-Large', size: 'xl', color: 'blue' },
    ]
  },
  {
    name: 'CheckBox Color',
    class: 'Class: [check sm / black, red, blue, purple]',
    type: 'checkColor',
    checkBoxList: [
      { text: 'Black', size: 'sm', color: 'black' },
      { text: 'Red', size: 'sm', color: 'red' },
      { text: 'Blue', size: 'sm', color: 'blue' },
      { text: 'Purple', size: 'sm', color: 'purple' },
      { text: 'Disabled', size: 'sm', color: 'purple', disabled: true },
      { text: 'Checked + Disabled', size: 'sm', color: 'purple', disabled: true, checked: true },
    ]
  },
]

const radioArr = [
  {
    name: 'Radio Button Size',
    class: 'Class: [check blue / xs, sm, md, lg, xl]',
    type: 'radioSize',
    radioList: [
      { text: 'X-Small', size: 'xs', color: 'blue' },
      { text: 'Small', size: 'sm', color: 'blue' },
      { text: 'Medium', size: 'md', color: 'blue' },
      { text: 'Large', size: 'lg', color: 'blue' },
      { text: 'X-Large', size: 'xl', color: 'blue' },
    ]
  },
  {
    name: 'Radio Button Color',
    class: 'Class: [check sm / black, red, blue, purple]',
    type: 'radioColor',
    radioList: [
      { text: 'Black', size: 'sm', color: 'black' },
      { text: 'Red', size: 'sm', color: 'red' },
      { text: 'Blue', size: 'sm', color: 'blue' },
      { text: 'Purple', size: 'sm', color: 'purple' },
      { text: 'Disabled', size: 'sm', color: 'purple', disabled: true },
      { text: 'Checked + Disabled', size: 'sm', color: 'purple', disabled: true, checked: true },
    ]
  },
]

const switchArr = [
  {
    name: 'Switch Button Size',
    class: 'Class: [switchBtn blue / xs, sm, md, lg, xl]',
    type: 'switchSize',
    switchList: [
      { onTxt: true, color: 'blue', size: 'xs', type: '', text: 'X-Small'},
      { onTxt: true, color: 'blue', size: 'sm', type: '', text: 'Small'},
      { onTxt: true, color: 'blue', size: 'md', type: '', text: 'Medium'},
      { onTxt: true, color: 'blue', size: 'lg', type: '', text: 'Large'},
      { onTxt: true, color: 'blue', size: 'xl', type: '', text: 'X-Large'},
    ]
  },
  {
    name: 'Basic Switch Button',
    class: 'Class: [switchBtn md / blue, red]',
    type: 'basicSwitch',
    switchList: [
      { onTxt: true, color: 'blue', size: 'md', type: '', text: 'Text switch - blue'},
      { onTxt: false, color: 'blue', size: 'md', type: '' , text: 'No text switch - blue'},
      { onTxt: true, color: 'red', size: 'md', type: '' , text: 'Text switch - red'},
      { onTxt: false, color: 'red', size: 'md', type: '' , text: 'No text switch - red'},
      { onTxt: true, color: 'blue', size: 'md', type: '' , text: 'Text switch disabled', disabled: true },
      { onTxt: false, color: 'red', size: 'md', type: '' , text: 'No text disabled', disabled: true },
    ]
  },
  {
    name: 'Filled Switch Button',
    class: 'Class: [switchBtn md / black, red / fill]',
    type: 'FilledSwitch',
    switchList: [
      { onTxt: true, color: 'blue', size: 'md', type: 'fill' , text: 'Filled text switch - blue'},
      { onTxt: false, color: 'blue', size: 'md', type: 'fill' , text: 'Filled no text switch - blue'},
      { onTxt: true, color: 'red', size: 'md', type: 'fill' , text: 'Filled text switch - red'},
      { onTxt: false, color: 'red', size: 'md', type: 'fill' , text: 'Filled no text switch - red'},
      { onTxt: true, color: 'blue', size: 'md', type: 'fill' , text: 'Filled text switch disabled', disabled: true },
      { onTxt: false, color: 'red', size: 'md', type: 'fill' , text: 'Filled no text switch disabled', disabled: true },
    ]
  },
]

const tagArr = [
  {
    name: 'Tag box size',
    class: 'Class: [tagBox round_100 / xs, sm, md, lg, xl]',
    tagList: [
      { size: 'xs', type: '', round: 'round_100', text: 'X-Small' },
      { size: 'sm', type: '', round: 'round_100', text: 'Small' },
      { size: 'md', type: '', round: 'round_100', text: 'Medium' },
      { size: 'lg', type: '', round: 'round_100', text: 'Large' },
      { size: 'xl', type: '', round: 'round_100', text: 'X-Large' },
    ]
  },
  {
    name: 'Tag box round',
    class: 'Class: [tagBox sm / round_10, round_100]',
    tagList: [
      { size: 'sm', type: '', round: 'round_10', text: 'Round 4px' },
      { size: 'sm', type: '', round: 'round_100', text: 'Round circle' },
    ]
  },
  {
    name: 'Tag box Type',
    class: 'Class: [tagBox sm round_100 / edge]',
    tagList: [
      { size: 'sm', type: '', round: 'round_100', text: 'Background' },
      { size: 'sm', type: 'edge', round: 'round_100', text: 'Edge' },
    ]
  }
]


export default UIElement;